module.exports = __webpack_public_path__ + "static/media/cart.e937f7a7.svg";